import { CommunityGroupIcon, CommunityMemberIcon, FinancialGroupIcon, FinancialMemberIcon, IconComponent, MedicalGroupIcon, MedicalMemberIcon, SchoolGroupIcon, SchoolMemberIcon, SocialGroupIcon, SocialMemberIcon, SpecialistsGroupIcon, SpecialistsMemberIcon } from '../theme/Icons';
import { ISupportGroupKey } from './ICareMap';

export interface ISupportGroupIcons {
    GroupIcon: IconComponent;
    MemberIcon: IconComponent;
};

export class SupportGroupIconProvider {

    getAllSupportGroupIcons = (): {[key in ISupportGroupKey]: ISupportGroupIcons} => {
        const icons: {[key in ISupportGroupKey]: ISupportGroupIcons} = {
            'community': {
                GroupIcon: CommunityGroupIcon,
                MemberIcon: CommunityMemberIcon,
            },
            'financial': {
                GroupIcon: FinancialGroupIcon,
                MemberIcon: FinancialMemberIcon,
            },
            'school':{
                GroupIcon: SchoolGroupIcon,
                MemberIcon: SchoolMemberIcon,
            },
            'medical': {
                GroupIcon: MedicalGroupIcon,
                MemberIcon: MedicalMemberIcon,
            },
            'specialists': {
                GroupIcon: SpecialistsGroupIcon,
                MemberIcon: SpecialistsMemberIcon,
            },
            'social': {
                GroupIcon: SocialGroupIcon,
                MemberIcon: SocialMemberIcon,
            }
        };

        return icons;
    };

    getSupportGroupIcons = (supportGroupKey: ISupportGroupKey): ISupportGroupIcons => {
        const { GroupIcon, MemberIcon } = this.getAllSupportGroupIcons()[supportGroupKey];
        return { GroupIcon, MemberIcon };
    };

}
